import React, { useEffect, useState, useContext, useRef } from "react";
import style from "./ProcesProduktTech.module.css";

import { ModalInsertContext } from "context/ModalInsertContext";
import { _typ_elementu, reg_int } from "utils/initialvalue";

import Window from "./components/Window";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { useProcessProdukt } from "./actions/useProcessProdukt";
import ProcesName from "./components/ProcesName";
import ProcessTyp from "./components/ProcesTyp";
import IloscUzytkow from "./components/IloscUzytkow";
import Naklad from "./components/Naklad";
import Info from "./components/Info";
import Indeks from "./components/Indeks";
import Usun from "./components/Usun";
export default function ProcesProduktTech() {

    const modalContext = useContext(ModalInsertContext);
  const showProcesyProduktow = modalContext.showProcesyProduktow;

if(showProcesyProduktow){
    return (
   <Window>
      <Header />
      <Table />
      <Footer />
   </Window>
  );
}

}

function Table2() {
  const contexModal = useContext(ModalInsertContext);
  const procesyProduktowTemporary = contexModal.procesyProduktowTemporary;
  const {addProcessProdukt} = useProcessProdukt();
const selectedOprawaRow = contexModal.selectedOprawaRow;

  return (
    <div className={style.main}>
      <table className={style.table}>
        <thead>
          <tr>
            {/* <th className={style.expand}>ID</th> */}
            <th className={style.expand}>#</th>
            <th className={style.col_proces}>Proces</th>
            <th className={style.col_proces}>Typ</th>
            <th className={style.col_ilosc_uzytkow}>Ilość użytków</th>
            <th className={style.col_naklad}>Naklad</th>

            <th className={style.col_wersja}>Opis</th>
            <th className={style.col_wersja}></th>
            {/* <th className={style.col_wersja}>Uwagi</th> */}
          </tr>
        </thead>
        <tbody>
          {procesyProduktowTemporary?.sort((a, b) => a.indeks - b.indeks)
          .filter((x) => x.delete != true)
          .filter((x) => x.oprawa_id == selectedOprawaRow.id)
          .map((row, i) => {
            return (
              <tr key={row.id}>
                {/* <td className={style.select_indeks}>{row.id}</td> */}
                <Indeks row={row}/>
                 <ProcesName row={row}/>
                 <ProcessTyp row={row}/> 
                 <IloscUzytkow row={row}/>
                 <Naklad row={row}/>
                <Info row={row}/>
                <Usun row={row}/> 
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className={style.dodaj_proces_row}>
         <button className={style.btnOutline} onClick={()=> addProcessProdukt()}> + Dodaj nowy proces</button>
      </div>
     
    </div>
  );
}


function Table() {
  const contexModal = useContext(ModalInsertContext);
  const procesyProduktowTemporary = contexModal.procesyProduktowTemporary;
  const setProcesyProduktowTemporary = contexModal.setProcesyProduktowTemporary; // Upewnij się, że masz setter w kontekście
  const { addProcessProdukt } = useProcessProdukt();
  const selectedOprawaRow = contexModal.selectedOprawaRow;

  // Wyciągnięcie i posortowanie widocznych wierszy dla wybranej oprawy
  const visibleRows = (procesyProduktowTemporary || [])
    .filter((x) => x.oprawa_id === selectedOprawaRow?.id)
    .filter((x) => x.delete !== true)
    .sort((a, b) => (Number(a.indeks) || 0) - (Number(b.indeks) || 0));

  const handleDragStart = (e, id) => {
    e.dataTransfer.setData("text/plain", id);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e, targetRow) => {
    e.preventDefault();
    const draggedId = e.dataTransfer.getData("text/plain");

    if (draggedId === String(targetRow.id)) return;

    const draggedIndex = visibleRows.findIndex((r) => String(r.id) === draggedId);
    const targetIndex = visibleRows.findIndex((r) => r.id === targetRow.id);

    if (draggedIndex === -1 || targetIndex === -1) return;

    const reorderedList = [...visibleRows];
    const [draggedItem] = reorderedList.splice(draggedIndex, 1);
    reorderedList.splice(targetIndex, 0, draggedItem);

    const updatedVisibleRowsMap = new Map(
      reorderedList.map((item, index) => [
        item.id,
        { ...item, indeks: index + 1, update: true },
      ])
    );

    setProcesyProduktowTemporary((prev) =>
      prev.map((item) => updatedVisibleRowsMap.get(item.id) || item)
    );
  };

  return (
    <div className={style.main}>
      <div className={style.tableWrapper}>
        <table className={style.table}>
          <thead>
            <tr>
              <th className={style.colDrag}></th>
              <th className={style.expand}>#</th>
              <th className={style.col_proces}>Proces</th>
              <th className={style.col_proces}>Typ</th>
              <th className={style.col_ilosc_uzytkow}>Ilość użytków</th>
              <th className={style.col_naklad}>Naklad</th>
              <th className={style.col_wersja}>Opis</th>
              <th className={style.col_wersja}></th>
            </tr>
          </thead>
          <tbody>
            {visibleRows.map((row) => (
              <tr
                key={row.id}
                draggable
                onDragStart={(e) => handleDragStart(e, row.id)}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, row)}
                className={style.draggableRow}
              >
                <td className={style.dragHandle} title="Przeciągnij, aby zmienić kolejność">
                  ⠿
                </td>
                <Indeks row={row} />
                <ProcesName row={row} />
                <ProcessTyp row={row} />
                <IloscUzytkow row={row} />
                <Naklad row={row} />
                <Info row={row} />
                <Usun row={row} />
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={style.dodaj_proces_row}>
        <button className={style.btnOutline} onClick={() => addProcessProdukt()}>
          + Dodaj nowy proces
        </button>
      </div>
    </div>
  );
}